import PageLayout from "../../components/common/page-layout";
import InvoiceEmails from "../../components/invoice-emails/invoice-emails";
import { RequireAuth } from "../../hooks/use-auth";

/** Route page for invoice email transmission logs and delivery status. */
const InvoiceEmailsPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="Invoice emails">
        <InvoiceEmails />
      </PageLayout>
    </RequireAuth>
  );
};

export default InvoiceEmailsPage;
